import React from 'react';
import { Edit } from 'react-admin';
import { t } from 'i18next';

import { CustomEditToolbar } from '../CustomEditToolbar';
import EditFormTitle from '../EditFormTitle';
import BreedForm from './BreedForm';

export const BreedEdit = props => (
  <Edit {...props} title={<EditFormTitle formName={t('breed')}/>}>
    <BreedForm toolbar={<CustomEditToolbar user={props.options.currentUser.role}/>}/>
  </Edit>
);